import { useState } from "react";
import { Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CardItem from "./CardItem";
import { Translate } from "../../../Enums/Tranlate";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import Pagination from "../../../common/Pagination/Pagination";
import RequestsService from "../../../../services/RequestsService";
import PreviousRequestsService from "../../../../services/PreviousRequestsService";
import { setSearch } from "../../../../store/actions/AuthActions";

const Requests = () => {
	const tabs = ["requests", "previous_requests"];
	const [selectTab, setSelectTab] = useState("requests");
	const [notification, setNotification] = useState([]);
	const [hasData, setHasData] = useState(0);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const dispatch = useDispatch();
	const requestsService = new RequestsService();
	const previousRequestsService = new PreviousRequestsService();
	const search = useSelector((state) => state.auth.search);

	return (
		<>
			<div className="tabs-div mb-4">
				{tabs?.map((tab, index) => {
					return (
						<p
							key={index}
							className={`${tab === selectTab ? "activeP" : ""}`}
							onClick={() => {
								setSelectTab(tab);
								dispatch(setSearch(""));
								setShouldUpdate((prev) => !prev);
							}}>
							{Translate[lang][tab]}
						</p>
					);
				})}
			</div>
			<div className="d-flex justify-content-between mb-3 align-items-center">
				<div>
					<span
						style={{
							fontWeight: "600",
							textTransform: "capitalize",
							color: "#000",
						}}>
						{Translate[lang][selectTab]}
					</span>
				</div>
			</div>
			<div>
				<div className={`${hasData === 0 ? "text-center" : "table-style"}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr className="text-center">
									<th>
										<strong>{Translate[lang].client_name}</strong>
									</th>
									<th>
										<strong>{Translate[lang].client_phone}</strong>
									</th>
									<th>
										<strong>{Translate[lang].date}</strong>
									</th>
									<th>
										<strong>{Translate[lang].entry_tiem}</strong>
									</th>
									<th>
										<strong>{Translate[lang].zone}</strong>
									</th>
									<th>
										<strong>{Translate[lang].floor}</strong>
									</th>
									<th>
										<strong>{Translate[lang].parking_slot}</strong>
									</th>
									<th>
										<strong>{Translate[lang].price}</strong>
									</th>
									<th>
										<strong>{Translate[lang].status}</strong>
									</th>
									{selectTab === "requests" && (
										<th>
											<strong>{Translate[lang].action}</strong>
										</th>
									)}
								</tr>
							</thead>

							<tbody className="table-body">
								{notification?.map((item, index) => {
									return (
										<CardItem
											index={index}
											key={index}
											item={item}
											selectTab={selectTab}
											setShouldUpdate={setShouldUpdate}
										/>
									);
								})}
							</tbody>
						</Table>
					)}
					{hasData === 0 && !loading && <NoData />}
					<Pagination
						setData={setNotification}
						service={
							selectTab === "requests"
								? requestsService
								: previousRequestsService
						}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						setLoading={setLoading}
						search={search}
					/>
				</div>
			</div>
		</>
	);
};

export default Requests;
